import usePlatform from '@/hooks/usePlatform';
import usePlatforms from '@/hooks/usePlatforms';
import useGameStore from '@/store';
import { useT } from '@/i18n/useLanguage';
import { Button, Portal } from '@chakra-ui/react';
import {
	MenuContent,
	MenuItem,
	MenuPositioner,
	MenuRoot,
	MenuTrigger,
} from '@chakra-ui/react/menu';
import { BiSolidChevronDown } from 'react-icons/bi';

const Platforms = () => {
	const selectedPlatformId = useGameStore((s) => s.gameQuery.platformId);
	const platform = usePlatform(selectedPlatformId);
	const setSelectedPlatformId = useGameStore((s) => s.setPlatformId);
	const t = useT();
	const { data: platforms, error } = usePlatforms();

	if (error) return null;

	return (
		<MenuRoot positioning={{ placement: 'bottom-start', gutter: 4 }}>
			<MenuTrigger asChild>
				<Button
					size="sm"
					variant="outline"
					rounded="md"
					borderColor="border"
					bg="bg.muted"
					fontWeight="600"
					_hover={{ borderColor: 'fg.muted' }}
				>
					{platform?.name || t('platforms')}
					<BiSolidChevronDown />
				</Button>
			</MenuTrigger>
			<Portal>
				<MenuPositioner>
					<MenuContent
						minW="200px"
						maxH="320px"
						overflowY="auto"
						rounded="lg"
						borderWidth="1px"
						borderColor="border"
						bg="bg.elevated"
						shadow="lg"
						py={1}
						css={{
							scrollbarWidth: 'none',
							'&::-webkit-scrollbar': { display: 'none' },
						}}
					>
						<MenuItem
							value="all"
							onClick={() => setSelectedPlatformId(undefined)}
							fontWeight={!selectedPlatformId ? '700' : '400'}
						>
							{t('allPlatforms')}
						</MenuItem>
						{platforms?.map((p) => (
							<MenuItem
								key={p.id}
								value={p.name}
								onClick={() => setSelectedPlatformId(p.id)}
								fontWeight={selectedPlatformId === p.id ? '700' : '400'}
							>
								{p.name}
							</MenuItem>
						))}
					</MenuContent>
				</MenuPositioner>
			</Portal>
		</MenuRoot>
	);
};

export default Platforms;
